export const leftContent = {
  width: "50%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};
export const centerDivContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};
export const rowHeading = {
  width: "50%",
  display: "flex",
  justifyContent: "flex-end",
};
export const rowHeadingLast = {
  display: "flex",
  justifyContent: "flex-end",
  marginLeft: "5rem",
};
export const leftContentData = {
  width: "70%",
  display: "flex",
  justifyContent: "flex-end",
  paddingRight: "1.3rem",
};
export const leftInputFom = {
  width: "5rem",
  display: "flex",
  justifyContent: "center",
};
export const rightInputForm = {
  display: "flex",
  justifyContent: "flex-end",
  width: "5rem",
  marginLeft: "5rem",
};
export const inputContainer = { width: "50px" };

export const RightTextContent = {
  justifyContent: "flex-start",
  marginLeft: "25px",
};
export const leftTextContent = {
  width: "15%",
  display: "flex",
  justifyContent: "flex-end",
  marginRight: "20px",
};
export const ml2 = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
};
export const rightContentInputBox = { width: "75%" };
export const strategicLabel = { justifyContent: "flex-start", display: "flex" };
export const functionLabel = {
  justifyContent: "flex-start",
  display: "flex",
  minWidth: "30%",
};
export const headingText = { fontSize: "18px", fontWeight: "600" };
export const textMargin = { margin: "5px 0px 15px 0px" };
export const overViewLeftText = {
  display: "flex",
  justifyContent: "flex-start",
  marginRight: "20px",
  width: "50%",
};
export const titleDiv = {
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "0.5rem",
  marginLeft: "1.5rem",
};
export const pecrIdDiv = {
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "row",
  marginLeft: "1.5rem",
};
export const titleName = {
  fontSize: "1.8rem",
  marginBottom: "1rem",
  fontWeight: "500",
  lineHeight: "1",
  color: "#0d6efd",
};
export const listDiv = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
};
export const functionsDiv = {
  marginLeft: "10rem",
  marginBottom: "0.5rem",
};
export const nameDiv = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
};
export const homeButtonComponent = {
  display: "flex",
  justifyContent: "center",
};
export const buttonDiv = {
  display: "flex",
  justifyContent: "center",
  gap: "4rem",
  marginRight: "1rem",
  marginTop: "2rem",
};
export const loaderDiv = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "15rem",
};
export const buttonStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const tableSection = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const backOverviewButtonDiv = {
  display: "flex",
  justifyContent: "center",
  marginTop: "1rem",
};
export const filterDropdown = {
  boxShadow: " 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  padding: "0.25rem",
  display: "none",
  width: "16rem",
  zIndex: "50",
  left: "0",
  maxHeight: "calc(100vh - 152px)",
  position: "absolute",
  marginTop: "0.5rem",
  backgroundColor: "white",
};
export const uploadedFilesGrid = {
  display: "flex",
  gap: "1.5rem",
  whiteSpace: "nowrap",
};

export const deleteFile = {
  marginRight: "5px",
  cursor: "pointer",
};
export const boldFont = {
  fontWeight: "bold",
  color: "#617080",
  textWrap: "nowrap",
};
export const SiteReviewValue = {
  marginLeft: "0.5rem",
};
export const SiteReviewTitle = {
  display: "flex",
  flexDirection: "row",
  marginLeft: "5rem",
  fontSize: "17px",
  marginBottom: "25px",
};
export const SiteImpactedDropdown = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  margin: "20px 0px 5px 80px",
};

export const LocalSiteDropdown = {
  width: "89%",
  marginLeft: "0.5rem",
};
export const LocalSiteComment = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  margin: "40px 0px 5px 80px",
  width: "92%",
};
export const LocalSiteButtons = {
  display: "flex",
  justifyContent: "space-around",
  gap: "4rem",
  marginRight: "1rem",
  paddingBottom: "1rem",
  marginTop: "3rem",
};

export const commentStyle = {
  height: "170px",
};

export const checkboxGrid = {
  position: "relative",
  top: "10px",
  right: "13px",
  columns: "2 auto",
  gap: "400px",
};

export const popupInfoGrid = {
  display: "flex",
  flexDirection: "row",
  margin: "0px 0px 20px 0px",
  fontSize: "17px",
  justifyContent: "center",
};

export const popupTitle = {
  fontSize: "1.5rem",
  fontWeight: "600",
  color: "#0d6efd",
};
export const checkboxLabel = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
export const selectAll = {
  position: "relative",
  top: "2px",
  right: "4px",
  cursor: "default",
};

export const reviewPageDropdown = {
  marginLeft: "0.5rem",
  width: "80%",
};

export const reviewPageLabel = {
  fontWeight: "bold",
  width: "20%",
  textAlignLast: "right",
  whiteSpace: "pre",
};

export const popupInformationGrid = {
  display: "flex",
  flexDirection: "row",
  margin: "15px 0px",
  fontSize: "17px",
};

export const EstimateLabel = {
  display: "flex",
  flexDirection: "row",
  marginLeft: "5rem",
  fontSize: "17px",
  marginBottom: "25px",
  border: "1px solid black",
  marginRight: "60px",
};

export const departmentFileUpload = {
  marginTop: "30px",
};

export const EffortCostGrid = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginLeft: "80px",
  marginRight: "80px",
};

export const DepartmentTitle = {
  display: "flex",
  flexDirection: "row",
  marginLeft: "5rem",
  fontSize: "17px",
  marginBottom: "25px",
  justifyContent: "space-between",
  marginRight: "5rem",
};

export const OwnerLSCComment = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  margin: "40px 0px 5px 80px",
  width: "96%",
};

export const GlobalSiteTable = {
  marginBottom: "25px",
  float: "left",
};

export const ReviewDoneMessage = {
  display: "flex",
  justifyContent: "center",
  marginTop: "100px",
  fontWeight: "600",
  fontSize: "17px",
  marginBottom: "100px",
  border: "2px solid rgb(48 79 162)",
  width: "500px",
  marginLeft: "37%",
  color: "rgb(48 79 162)",
  padding: "20px",
  backgroundColor: "aliceblue",
  borderRadius: "5px",
};

export const DisabledCSS = {
  pointerEvents: "none",
};
export const DisabledLink = {
  color: "gray",
};

export const editLSC = {
  margin: "0px 0px 1px 15px",
  cursor: "pointer",
  position: "relative",
  right: "0.5%",
};

export const descriptionLSC = {
  height: "170px",
  width: "400%",
};
export const descriptionLSCGrid = {
  marginLeft: "1%",
};
export const hidden = {
  visibility: "hidden",
};

export const ReviewMessage = {
  display: "flex",
  justifyContent: "center",
  fontWeight: "600",
  fontSize: "17px",
  border: "2px solid rgb(48 79 162)",
  width: "500px",
  marginLeft: "37%",
  color: "rgb(48 79 162)",
  padding: "20px",
  backgroundColor: "aliceblue",
  borderRadius: "5px",
};

export const lscDescriptionValue = {
  marginLeft: "0.5rem",
  wordWrap: "break-word",
  width: "50%",
};

export const OwnerlscValue = {
  marginLeft: "0.5rem",
  wordWrap: "break-word",
  width: "90%",
};

export const GCValue = {
  marginLeft: "0.5rem",
  wordWrap: "break-word",
  width: "85%",
};

export const FinalValue = {
  marginLeft: "0.5rem",
  wordWrap: "break-word",
  width: "100%",
};

export const TextAsLink = {
  color: "#0a58ca",
  textDecoration: "underline",
  cursor: "pointer",
};

export const FieldsetStyle = {
  border: "1.5px solid black",
  padding: "20px",
  borderRadius: "10px",
};

export const LegendStyle = {
  padding: "0px 5px",
  fontWeight: "600",
};

export const ExecutionEffortCostGrid = {
  display: "flex",
  flexDirection: "row",
  marginLeft: "80px",
  marginRight: "80px",
  marginBottom: "20px",
};

export const UploadedDocument = {
  fontWeight: "bold",
  marginTop: "10px",
};

export const ReviewComment = {
  display: "flex",
  flexDirection: "column",
  fontSize: "17px",
  margin: "40px 0px 5px 80px",
  width: "96%",
};

export const ReviewGeneralComment = {
  display: "flex",
  flexDirection: "column",
  fontSize: "17px",
  margin: "60px 0px 5px 150px",
  width: "100%",
};

export const commentLabel = {
  fontWeight: "bold",
  textWrap: "nowrap",
  marginBottom: "10px",
  marginTop: "5px",
};

export const commentGeneralStyle = {
  height: "190px",
};

export const noFileText = {
  marginLeft: "-15px",
  fontWeight: "normal",
};

export const progressBar = {
  width: "33%",
  marginLeft: "33%",
  marginTop: "5%",
};

export const ownerLSCUploadPosition = {
  display: "flex",
  alignItems: "center",
  gap: "1.5rem",
  whiteSpace: "nowrap",
};

export const TrackingInfo = {
  padding: "10px",
  // boxShadow: "5px 5px #CCCCCC",
};

export const TrackingInfoDrivers = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginBottom: "15px",
};

export const ListFilterTableGrid = {
  display: "flex",
  flexWrap: "nowrap",
  gap: "15px",
};

export const FilterTypeGrid = {
  marginTop: "10px",
  border: "1px solid rgba(224, 224, 224, 1)",
};

export const ListMainGrid = {
  position: "relative",
  right: "145px",
};

export const SaveIconStyle = {
  display: "flex",
  alignItems: "center",
  marginRight: "5px",
};

export const pointerCursor = {
  cursor: "pointer",
};

export const rotateIcon = {
  cursor: "pointer",
  transform: "rotateZ(180deg)",
};

export const saveModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  backgroundColor: "white",
  border: "1px solid #000",
  padding: "10px",
  borderRadius: "5px",
  outline: "none",
};

export const saveModalButtonGrid = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  marginBottom: "15px",
};

// custom style for my saved view drop-down
export const SavedViewStyle = {
  control: (provided) => ({
    ...provided,
    margin: "10px 0px 10px 10px",
    width: "240px",
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

// custom style for drop-down on DM page
export const DMDropdownStyle = {
  control: (provided) => ({
    ...provided,
    margin: "10px 0px 10px 0px",
    padding: "4px 0px 4px 0px",
    width: "300px",
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

export const blueColor = {
  color: "#0a58ca",
};

export const EditAddUserModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  backgroundColor: "white",
  border: "2px solid #000",
  padding: "10px",
  borderRadius: "15px",
  outline: "none",
};

export const UserModalLabel = {
  fontWeight: "bold",
  width: "180px",
  textAlignLast: "right",
  whiteSpace: "pre",
};
export const UserModelValue = {
  marginLeft: "0.5rem",
  width: "250px",
};
export const UserModelGrid = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  marginBottom: "25px",
  justifyContent: "center",
};

export const UserModalHeading = {
  color: "#0d6efd",
  padding: "10px 0px 30px 40px",
  fontWeight: "bold",
};

export const EditAddUserModalLoader = {
  position: "fixed",
  top: "50%",
  left: "50%",
  width: "100%",
  height: "100%",
  zIindex: "9999",
};

export const TrackingDrivers = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  marginBottom: "15px",
};

export const TrackingDriversLabel = {
  display: "flex",
  justifyContent: "flex-start",
  marginRight: "20px",
  width: "40%",
};

export const TrackingInfoGrid = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
};

export const showAllStep = {
  marginTop: "20px",
  cursor: "pointer",
  width: "fit-content",
  padding: "5px",
};

export const SummaryAccordionStyle = {
  marginTop: "15px",
  "&:before": {
    height: "0px",
    display: "none",
  },
  ".MuiAccordionSummary-root": {
    padding: "0px",
  },
};

export const pageGrid = {
  paddingLeft: "2rem",
  marginBottom: "2rem",
};

export const siteDetails = {
  borderTop: "2px black solid",
  margin: "25px 20px 0px 20px",
  padding: "25px",
};

export const siteDetailsGrid = {
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  marginTop: "5px",
  alignItems: "center",
  padding: "10px",
};

export const resourceDropdown = {
  width: "50%",
  marginLeft: "0.5rem",
};

export const RMdepartmentLabel = {
  wordWrap: "break-word",
  width: "100%",
  fontWeight: "bold",
  margin: "10px 0px 5px 0px",
};

export const marginBottom5 = {
  marginBottom: "5rem",
};

export const HomeComponentDiv = {
  display: "flex",
  height: "auto",
  justifyContent: "space-around",
  marginTop: "6rem",
};

export const HomeBoxDiv = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  padding: " 15px",
  textAlign: "left",
  border: "1px solid rgba(0,0,0,.125)",
  width: "20%",
};

export const HomeButtonDiv = {
  display: "block",
  width: "100%",
  padding: "7px",
  textAlign: "center",
  marginTop: "auto",
};

export const validationError = {
  color: "red",
};

export const validationErrorOnPages = {
  color: "red",
  fontSize: "17px",
  margin: "10px 0px 5px 80px",
};

export const whiteColor = {
  color: "white",
};

export const buttonCircularProgress = {
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-15px",
  marginLeft: "-12px",
};

export const detailedIconButtonStyle = {
  margin: "0px 10px 10px 0px",
  "&:hover": {
    backgroundColor: "white",
  },
};
export const detailedIconStyle = {
  fontSize: 40,
};

export const filterAccordionSummary = {
  width: "253px",
  height: "50px",
};

export const DescriptionOverview = {
  height: "250px",
};

export const driversContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: "15px",
};

export const overviewContainers = {
  margin: "15px 0px",
};

export const helpIcon = {
  fontSize: 17,
  position: "relative",
  top: "5px",
  left: "15px",
};

export const summaryAccordionIcon = {
  fontSize: "40px",
  color: "black",
};

export const summaryEditIcon = {
  fontSize: 28,
  color: "#0a58ca",
  cursor: "pointer",
};

export const summaryEditScoreIcon = {
  fontSize: 26,
  cursor: "pointer",
  marginRight: "15px",
  fontWeight: "normal",
};

export const summaryValueScoreGrid = {
  display: "flex",
  marginBottom: "20px",
  justifyContent: "center",
  alignItems: "center",
};

export const summaryEditScoreGrid = {
  display: "flex",
  gap: 2,
  alignItems: "center",
};

export const VSInfoGrid = {
  display: "flex",
  flexDirection: "row",
  margin: "10px 0px",
  gap: "5px",
};

export const VSInfoValue = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  fontSize: "17px",
};

export const VSModalHeader = {
  display: "flex",
  justifyContent: "center",
  fontWeight: "bolder",
  fontSize: "25px",
};

export const VSModalJustification = {
  width: 530,
  marginTop: "20px",
};

export const VSModalLoader = {
  position: "absolute",
  top: "50%",
  left: "50%",
};

export const summaryDeleteIcon = {
  fontSize: 32,
  color: "#0a58ca",
  cursor: "pointer",
};

export const DeletePECRConfirmation = {
  fontWeight: "bold",
  fontSize: "20px",
};

export const costImpactMain = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "1px solid black",
  justifyContent: "center",
  height: "auto",
  marginTop: "2%",
};

export const costImpactHeader = {
  backgroundColor: "#1F305E",
  color: "white",
  padding: "10px 0px",
  fontWeight: "bold",
  fontSize: "18px",
};

export const costImpactValueGrid = {
  height: "auto",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const height30px = {
  height: "30px",
};

export const ownerLSCInput = {
  border: "1px solid black",
  padding: "0px 5px",
  borderRadius: "5px 0px 0px  5px ",
  marginRight: "10px",
};

export const costImpactdisplayFiles = {
  marginLeft: "2%",
  padding: "10px 0px",
  maxWidth: "auto",
  overflow: "auto",
};

export const noFileUploaded = {
  margin: "0px 0px 0px -15px",
  fontWeight: "normal",
};

export const detailedListColumn1 = {
  position: "sticky",
  left: 0,
  zIndex: 100,
  backgroundColor: "white",
};
export const detailedListHeader1 = {
  position: "sticky",
  left: 0,
  top: 0,
  zIndex: 200,
  backgroundColor: "white",
};
export const detailedListColumn2 = {
  position: "sticky",
  left: "5.5%",
  zIndex: 100,
  backgroundColor: "white",
};
export const detailedListHeader2 = {
  position: "sticky",
  left: "5.5%",
  top: 0,
  zIndex: 200,
  backgroundColor: "white",
};
export const detailedListColumn3 = {
  position: "sticky",
  left: "17.5%",
  zIndex: 100,
  backgroundColor: "white",
};

export const detailedListHeader3 = {
  position: "sticky",
  left: "17.5%",
  top: 0,
  zIndex: 200,
  backgroundColor: "white",
};
